module.exports = __webpack_public_path__ + "img/BLCN.ac426a63.svg";